import { render, staticRenderFns } from "./ListActiveInfo.vue?vue&type=template&id=18772a8b&scoped=true&"
import script from "./ListActiveInfo.vue?vue&type=script&lang=js&"
export * from "./ListActiveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18772a8b",
  null
  
)

export default component.exports